import { useState } from 'react'

const useShowItem = () => {
  const [showItemModal, setShowItemModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const onSelectItem = item => {
    setSelectedItem(item)
    setShowItemModal(true)
  }

  const onCloseItemModal = () => {
    setShowItemModal(false)
  }

  const onOpenItemModal = () => {
    setShowItemModal(true)
  }

  return {
    selectedItem,
    showItemModal,
    onSelectItem,
    onCloseItemModal,
    onOpenItemModal,
  }
}

export default useShowItem
